import { createRouter, createWebHashHistory } from "vue-router";
import { localdata } from "@/data/localdata";

// 路由配置
const routes = [
  // 根路径重定向到登录页面
  {
    path: "/",
    redirect: "/login",
  },
  //登录页面
  {
    path: "/login",
    name: "ReimbursementLogin",
    component: () => import("../views/finance/ReimbursementLogin.vue"),
  },
  // 财务报销系统路由 - 官网
  {
    path: "/",
    name: "Home",
    children: [ // 官网页面
      {
        path: "/index",
        name: "OfficialWebsite",
        component: () => import("../views/finance/home/OfficialWebsite.vue"),
      },
      // 隐私政策页面
      {
        path: "/privacy-policy",
        name: "PrivacyPolicy",
        component: () => import("../views/finance/home/PrivacyPolicy.vue"),
      },
      // 用户协议页面
      {
        path: "/user-agreement",
        name: "UserAgreement",
        component: () => import("../views/finance/home/UserAgreement.vue"),
      },
    ]
  },
  // 财务报销系统路由 - 管理端
  {
    path: "/finance/admin",
    component: () => import("../layouts/NewAdminLayout.vue"),
    children: [
      {
        path: "dashboard",
        name: "admindashboard",
        component: () => import("../views/finance/admin/Homepage/AdminDashbord.vue"),
        meta: { group: "首页", icon: "House", title: "首页" },
      },
      {
        path: "AdminUserProfile",
        name: "AdminUserProfile",
        component: () => import("../views/finance/admin/UserManagement/AdminUserProfile.vue"),
        meta: { group: "个人中心", icon: "User", title: "个人中心" },
      },
      {
        path: "AdminFunctionModules",
        name: "AdminFunctionModules",
        component: () => import("../views/finance/admin/Others/AdminFunctionModules.vue"),
        meta: { group: "功能模块", icon: "Menu", title: "工作台" },
      },
      //收入部分
      {
        path: "AdminIncomeRecords",
        name: "AdminIncomeRecords",
        component: () => import("../views/finance/admin/Incomemanagement/AdminIncomeRecords.vue"),
        meta: {
          group: "收入管理",
          icon: "Tickets",
          title: "收入记录",
        },
      },
      {
        path: "admin-revenue-analytics",
        name: "AdminRevenueManagement",
        component: () => import("../views/finance/admin/Incomemanagement/AdminRevenueManagement.vue"),
        meta: {
          group: "收入管理",
          icon: "DataAnalysis",
          title: "收入报表",
        },
      },
      {
        path: "AdminRevenueSummary",
        name: "AdminRevenueSummary",
        component: () => import("../views/finance/admin/Incomemanagement/AdminRevenueSummary.vue"),
        meta: {
          group: "收入管理",
          icon: "PieChart",
          title: "收入汇总",
        },
      },
      {
        path: "chainMyJotdown",
        name: "chainMyJotdown",
        component: () => import("../views/finance/admin/Reimbursement/chainMyJotdown.vue"),
        meta: { group: "报销管理", icon: "EditPen", title: "随手记" },
      },
      {
        path: "AdminReimbursementForm",
        name: "AdminReimbursementForm",
        component: () => import("../views/finance/admin/Reimbursement/AdminReimbursementForm.vue"),
        meta: { group: "报销管理", icon: "Edit", title: "日常报销" },
      },
      {
        path: "chainKBFReimbursementForm",
        name: "chainKBFReimbursementForm",
        component: () => import("../views/finance/admin/Reimbursement/chainKBFReimbursementForm.vue"),
        meta: { group: "报销管理", icon: "DocumentAdd", title: "开办报销" },
      },
      {
        path: "my-reimbursements",
        name: "AdminMyReimbursements",
        component: () => import("../views/finance/admin/Reimbursement/MyReimbursements.vue"),
        meta: { group: "报销管理", icon: "List", title: "我的报销" },
      },
      {
        path: "adminreimbursementsdashboard",
        name: "AdminReimbursementsDashboard",
        component: () => import("../views/finance/admin/Reimbursement/AdminReimbursementDashboard.vue"),
        meta: { group: "报销管理", icon: "Odometer", title: "报销统计" },
      },
      {
        path: "reimbursements",
        name: "AdminReimbursements",
        component: () => import("../views/finance/admin/Reimbursement/AdminReimbursements.vue"),
        meta: { group: "报销管理", icon: "Files", title: "门店报销" },
      },
      // {
      //   path: "adminreimburcategroy",
      //   name: "AdminReimburCategroy",
      //   component: () => import("../views/finance/admin/Reimbursement/AdminReimburCategroy.vue"),
      //   meta: { group: "报销管理", icon: "Collection", title: "分类统计" },
      // },
      {
        path: "store-employee-management",
        name: "AdminStoreEmployeeManagement",
        component: () => import("../views/finance/admin/UserManagement/StoreEmployeeManagement.vue"),
        meta: { group: "员工管理", icon: "UserFilled", title: "员工管理" },
      },
      {
        path: "store-role-management",
        name: "AdminStoreRoleManagement",
        component: () => import("../views/finance/admin/UserManagement/StoreRoleManagement.vue"),
        meta: { group: "员工管理", icon: "Key", title: "角色管理" },
      },
      {
        path: "chain-store-employee-management",
        name: "chainAdminStoreEmployeeManagement",
        component: () => import("../views/finance/admin/UserManagement/chainStoreManagement.vue"),
        meta: { group: "集团管理", icon: "OfficeBuilding", title: "门店管理" },
      },
      {
        path: "chain-employee-loan",
        name: "chainEmployeeLoan",
        component: () => import("../views/finance/admin/UserManagement/chainEmployeeLoan.vue"),
        meta: { group: "员工管理", icon: "Money", title: "个人借款" },
      },
      {
        path: "chain-employee-loan-management",
        name: "chainEmployeeLoanManagement",
        component: () => import("../views/finance/admin/UserManagement/chainEmployeeLoanManagement.vue"),
        meta: { group: "员工管理", icon: "Wallet", title: "借款明细" },
      },
      {
        path: "chain-employee-loan-audit",
        name: "chainEmployeeLoanAudit",
        component: () => import("../views/finance/admin/UserManagement/chainEmployeeLoanAudit.vue"),
        meta: { group: "员工管理", icon: "Checked", title: "借款审核" },
      },
      {
        path: "chain-users-employee-management",
        name: "chainUsersEmployeeManagement",
        component: () => import("../views/finance/admin/CustomerManagement/chainUsersManagement.vue"),
        meta: { group: "客户管理", icon: "Avatar", title: "集团账号" },
      },
      {
        path: "store-management",
        name: "StoreManagement",
        component: () => import("../views/finance/admin/UserManagement/StoreManagement.vue"),
        meta: { group: "客户管理", icon: "Shop", title: "门店管理" },
      },
      {
        path: "store-reimbursement-audit",
        name: "AdminStoreReimbursementAudit",
        component: () => import("../views/finance/admin/Reimbursement/StoreReimbursementAudit.vue"),
        meta: { group: "报销管理", icon: "Checked", title: "报销审核" },
      },
      {
        path: "store-reimbursement-chainCCreceived",
        name: "chainCCreceived",
        component: () => import("../views/finance/admin/Reimbursement/chainCCreceived.vue"),
        meta: { group: "报销管理", icon: "Message", title: "我的抄送" },
      },
      {
        path: "AdminReimbursementformcategorymodification",
        name: "AdminReimbursementFormCategoryModification",
        component: () => import("../views/finance/admin/Reimbursement/AdminReimbursementformcategorymodification.vue"),
        meta: { group: "报销管理", icon: "Edit", title: "报销单修改" },
        
      },
      {
        path: "employeemanagements",
        name: "AdminEmployeeManagement",
        component: () => import("../views/finance/admin/UserManagement/AdminEmployeeManagement.vue"),
        meta: { group: "集团管理", icon: "User", title: "子账号管理" },
      },
      {
        path: "rolemanagements",
        name: "AdminRoleManagement",
        component: () => import("../views/finance/admin/UserManagement/AdminRoleManagement.vue"),
        meta: { group: "集团管理", icon: "Lock", title: "子账号角色" },
      },
      {
        path: "admin-employee-payroll-management",
        name: "AdminEmployeePayrollManagement",
        component: () => import("../views/finance/admin/UserManagement/AdminEmployeePayrollManagement.vue"),
        meta: { group: "员工管理", icon: "Wallet", title: "工资管理" },
      },
      {
        path: "admin-set-employee-payroll",
        name: "AdminSetEmployeePayroll",
        component: () => import("../views/finance/admin/UserManagement/AdminSetEmployeePayroll.vue"),
        meta: { group: "员工管理", icon: "SetUp", title: "默认工资" },
      },
      {
        path: "AdminZJWLCompany",
        name: "AdminZJWLCompany",
        component: () => import("../views/finance/admin/Financialmanagement/AdminZJWLCompany.vue"),
        meta: {
          group: "资金往来",
          icon: "OfficeBuilding",
          title: "往来单位",
        },
      },
       // 拉卡拉交易中心
      
      {
        path: "transfer-application-list",
        name: "ChainTransferApplicationList",
        component: () => import("../views/finance/admin/LKL/TransferApplicationList.vue"),
        meta: { group: "交易中心", icon: "Tickets", title: "企业支付" },
      },
       {
        path: "bank-account-query",
        name: "BankAccountQuery",
        component: () => import("../views/finance/admin/LKL/BankAccountQuery.vue"),
        meta: { group: "交易中心", icon: "Bankcard", title: "银行账户查询" },
      },
      {
        path: "lakala-personal-account",
        name: "LakalaPersonalAccount",
        component: () => import("../views/finance/store/LKL/PersonalAccountOpen.vue"),
        meta: { group: "交易中心", icon: "Exchange", title: "个人开户" },
      },
      {
        path: "zcmaterials-management",
        name: "adminZCMaterialsManagement",
        component: () => import("../views/finance/admin/Materialsmanagement/ZCMaterialsManagement.vue"),
        meta: { group: "资产管理", icon: "Box", title: "资产库存" },
      },
      {
        path: "zcmaterials-category",
        name: "adminZCMaterialsCategory",
        component: () => import("../views/finance/admin/Materialsmanagement/ZCMaterialsCategory.vue"),
        meta: { group: "资产管理", icon: "Grid", title: "资产分类" },
      },
      //股东部分
      {
        path: "admin-shareholder-info",
        name: "AdminShareholderInfo",
        component: () => import("../views/finance/admin/Shareholermanagement/AdminShareholderInfo.vue"),
        meta: { group: "股东管理", icon: "User", title: "股东信息" },
      },
      {
        path: "admin-shareholder-investment",
        name: "AdminShareholderInvestment",
        component: () => import("../views/finance/admin/Shareholermanagement/AdminShareholderInvestment.vue"),
        meta: { group: "股东管理", icon: "Coin", title: "投资明细" },
      },
      {
        path: "admin-shareholder-dividend",
        name: "AdminShareholderDividend",
        component: () => import("../views/finance/admin/Shareholermanagement/AdminShareholderDividend.vue"),
        meta: { group: "股东管理", icon: "Money", title: "分红记录" },
      },
      {
        path: "admin-shareholder-analytics",
        name: "AdminShareholderAnalytics",
        component: () => import("../views/finance/admin/Shareholermanagement/AdminShareholderAnalytics.vue"),
        meta: { group: "股东管理", icon: "TrendCharts", title: "报表分析" },
      },
      {
        path: "chainMyShareholder",
        name: "chainMyShareholder",
        component: () => import("../views/finance/admin/Shareholermanagement/chainMyShareholder.vue"),
        meta: { group: "股东管理", icon: "UserFilled", title: "我的股权" },
      },
      {
        path: "chainInvestmentProjects",
        name: "chainInvestmentProjects",
        component: () => import("../views/finance/admin/Investmentmanagerment/chainInvestmentProjectManagement.vue"),
        meta: { group: "投资管理", icon: "OfficeBuilding", title: "项目单位" },
      },
      {
        path: "chainInvestmentRecords",
        name: "chainInvestmentRecords",
        component: () => import("../views/finance/admin/Investmentmanagerment/chainInvestmentRecordManagement.vue"),
        meta: { group: "投资管理", icon: "Document", title: "投资记录" },
      },
      {
        path: "chainInvestmentAnalytics",
        name: "chainInvestmentAnalytics",
        component: () => import("../views/finance/admin/Investmentmanagerment/chainInvestmentAnalytics.vue"),
        meta: { group: "投资管理", icon: "DataAnalysis", title: "投资分析" },
      },
      
      
      {
        path: "AdminZJWL",
        name: "AdminZJWL",
        component: () => import("../views/finance/admin/Financialmanagement/AdminZJWL.vue"),
        meta: {
          group: "资金往来",
          icon: "Money",
          title: "往来管理",
        },
      },
      // {
      //   path: 'target',
      //   component: () => import('@/views/finance/admin/target/TargetManagement.vue'),
      //   name: 'ChainTarget',
      //   meta: { group: "目标管理", title: '目标管理', icon: 'trend-charts' }
      // },
      // {
      //   path: 'region',
      //   component: () => import('@/views/finance/admin/target/RegionManagement.vue'),
      //   name: 'ChainRegion',
      //   meta: { group: "目标管理", title: '区域管理', icon: 'map-location' }
      // },
      // {
      //   path: 'reward',
      //   component: () => import('@/views/finance/admin/target/RewardManagement.vue'),
      //   name: 'ChainReward',
      //   meta: { group: "目标管理", title: '奖励管理', icon: 'present' }
      // },
      // {
      //   path: 'tracking',
      //   component: () => import('@/views/finance/admin/target/TargetTracking.vue'),
      //   name: 'ChainTracking',
      //   meta: { group: "目标管理", title: '执行跟踪', icon: 'data-line' }
      // },
      // {
      //   path: 'targetanalysis',
      //   component: () => import('@/views/finance/admin/target/TargetAnalysis.vue'),
      //   name: 'ChainAnalysis',
      //   meta: { group: "目标管理", title: '目标分析', icon: 'data-analysis' }
      // },
      // {
      //   path: 'my-targets',
      //   component: () => import('@/views/finance/admin/target/MyTargets.vue'),
      //   name: 'MyTargets',
      //   meta: { group: "目标管理", title: '个人目标', icon: 'user' }
      // },
      // {
      //   path: 'targetdistribution',
      //   component: () => import('@/views/finance/admin/target/RewardDistribution.vue'),
      //   name: 'RewardDistribution',
      //   meta: { group: "目标管理", title: '奖励发放', icon: 'present' }
      // },
      {
        path: "store-category-management",
        name: "AdminStoreCategoryManagement",
        component: () => import("../views/finance/admin/Reimbursement/StoreCategoryManagement.vue"),
        meta: { group: "财务设置", icon: "Operation", title: "报销分类" },
      },
      {
        path: "income-category",
        name: "AdminIncomeCategoryManagement",
        component: () => import("../views/finance/admin/Incomemanagement/AdminIncomeCategoryManagement.vue"),
        meta: {
          group: "财务设置",
          icon: "Folder",
          title: "收入分类",
        },
      },
      {
        path: "AdminClassRelevance",
        name: "AdminClassRelevance",
        component: () => import("../views/finance/admin/Homepage/AdminClassRelevance.vue"),
        meta: { group: "财务设置", icon: "Connection", title: "分类关联" },
      },
      {
        path: "store-audit-settings",
        name: "AdminStoreAuditSettings",
        component: () => import("../views/finance/admin/Reimbursement/StoreAuditSettings.vue"),
        meta: { group: "财务设置", icon: "Tools", title: "审核设置" },
      },
      {
        path: "Cashbalance",
        name: "AdminCashbalance",
        component: () => import("../views/finance/admin/Homepage/AdminCashbalance.vue"),
        meta: { group: "财务设置", icon: "SetUp", title: "资金设置" },
      },
      {
        path: "category-sync",
        name: "CategorySync",
        component: () => import("../views/finance/admin/Others/ChaindataSync.vue"),
        meta: { group: "财务设置", icon: "Connection", title: "同步设置" },
      },
      {
        path: "AdminStoreSetup",
        name: "AdminStoreSetup",
        component: () => import("../views/finance/admin/Others/AdminStoreSetup.vue"),
        meta: { group: "财务设置", icon: "SetUp", title: "基础设置" },
      },
      {
        path: "adminGPReporting",
        name: "adminGPReporting",
        component: () => import("../views/finance/admin/Others/GPReporting.vue"),
        meta: { group: "收入管理", icon: "TrendingUp", title: "毛利报表" },
      },
      {
        path: "AdminNewsPublish",
        name: "AdminNewsPublish",
        component: () => import("../views/finance/admin/Others/AdminNewsPublish.vue"),
        meta: { group: "客户管理", icon: "Bell", title: "发布通知" },
      },
      {
        path: "attachmentManagement",
        name: "AttachmentManagementpage",
        component: () => import("../views/finance/admin/Others/AttachmentManagement.vue"),
        meta: { group: "其他", icon: "Document", title: "附件管理" },
      },
      {
        path: "attachmentManagemen",
        name: "AttachmentManagementpae",
        component: () => import("../views/finance/admin/Others/AttachmentManagement.vue"),
        meta: { group: "其他", icon: "Document", title: "附件管理 1" },
      },
     
      // {
      //   path: "lakala-personal-account-query",
      //   name: "LakalaPersonalAccountQuery",
      //   component: () => import("../views/finance/store/LKL/PersonalAccountQuery.vue"),
      //   meta: { group: "交易中心", icon: "Document", title: "开户结果查询" },
      // },
      // {
      //   path: "lakala-account-query",
      //   name: "LakalaAccountQuery",
      //   component: () => import("../views/finance/store/LKL/LakalaAccountQuery.vue"),
      //   meta: { group: "交易中心", icon: "List", title: "账户查询" },
      // },
      {
        path: "personal-account-info-query",
        name: "PersonalAccountInfoQuery",
        component: () => import("../views/finance/store/LKL/PersonalAccountInfoQuery.vue"),
        meta: { group: "交易中心", icon: "User", title: "个人钱包" },
      },
        {
        path: "personal-transaction-query",
        name: "PersonalTransactionQuery",
        component: () => import("../views/finance/store/LKL/PersonalTransactionQuery.vue"),
        meta: { group: "交易中心", icon: "Document", title: "钱包查询" },
      },
      {
        path: "transaction-apply",
        name: "TransactionApply",
        component: () => import("../views/finance/store/LKL/TransactionApply.vue"),
        meta: { group: "交易中心", icon: "Edit", title: "退款申请" },
      },
      {
        path: "transaction-confirm",
        name: "TransactionConfirm",
        component: () => import("../views/finance/store/LKL/TransactionConfirm.vue"),
        meta: { group: "交易中心", icon: "Check", title: "交易确认" },
      },
    
      {
        path: "store-transaction-query",
        name: "StoreTransactionQuery",
        component: () => import("../views/finance/store/LKL/StoreTransactionQuery.vue"),
        meta: { group: "交易中心", icon: "Shop", title: "交易查询" },
      },
      
      {
        path: "lakala-account-list",
        name: "LakalaAccountList",
        component: () => import("../views/finance/admin/LKL/LakalaAccountList.vue"),
        meta: { group: "交易中心", icon: "List", title: "账户列表查询" },
      },
      
    ],
  },
  // 财务报销系统路由 - 门店端
  {
    path: "/finance/store",
    component: () => import("../layouts/NewStoreLayout.vue"),
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("../views/finance/store/Homepage/DashBord.vue"),
        meta: { group: "首页", icon: "House", title: "首页" },
      },
      {
        path: "FunctionModules",
        name: "FunctionModules",
        component: () => import("../views/finance/store/Others/FunctionModules.vue"),
        meta: { group: "功能模块", icon: "Menu", title: "工作台" },
      },
      // 收入部分
      {
        path: "income-records",
        name: "IncomeRecords",
        component: () => import("../views/finance/store/Incomemanagement/IncomeRecords.vue"),
        meta: { group: "收入管理", icon: "Tickets", title: "收入记录" },
      },
      {
        path: "income-analytics",
        name: "RevenueManagement",
        component: () => import("../views/finance/store/Incomemanagement/RevenueManagement.vue"),
        meta: { group: "收入管理", icon: "DataAnalysis", title: "收入报表" },
      },
      {
        path: "income-revenuesummary",
        name: "RevenueSummary",
        component: () => import("../views/finance/store/Incomemanagement/RevenueSummary.vue"),
        meta: { group: "收入管理", icon: "PieChart", title: "收入汇总" },
      },
      //报销管理首页
      {
        path: "MyJotdown",
        name: "MyJotdown",
        component: () => import("../views/finance/store/Reimbursement/MyJotdown.vue"),
        meta: { group: "报销管理", icon: "EditPen", title: "随手记" },
      },
      {
        path: "ReimbursementDashboard",
        name: "ReimbursementDashboard",
        component: () => import("../views/finance/store/Reimbursement/ReimbursementDashboard.vue"),
        meta: { group: "报销管理", icon: "TrendCharts", title: "报销统计" },
      },
      {
        path: "reimbursement-form",
        name: "ReimbursementForm",
        component: () => import("../views/finance/store/Reimbursement/ReimbursementForm.vue"),
        meta: { group: "报销管理", icon: "Edit", title: "日常报销" },
      },
      {
        path: "kbf-reimbursement-form",
        name: "KBFReimbursementForm",
        component: () => import("../views/finance/store/Reimbursement/KBFReimbursementForm.vue"),
        meta: { group: "报销管理", icon: "DocumentAdd", title: "开办报销" },
      },
      {
        path: "my-reimbursements",
        name: "MyReimbursements",
        component: () => import("../views/finance/store/Reimbursement/MyReimbursements.vue"),
        meta: { group: "报销管理", icon: "List", title: "我的报销" },
      },
      {
        path: "CCreceived",
        name: "CCreceived",
        component: () => import("../views/finance/store/Reimbursement/CCreceived.vue"),
        meta: { group: "报销管理", icon: "Message", title: "我的抄送" },
      },
      {
        path: "employee-reimbursements",
        name: "StoreManagerReimbursements",
        component: () => import("../views/finance/store/Reimbursement/StoreManagerReimbursements.vue"),
        meta: { group: "报销管理", icon: "User", title: "报销记录" },
      },
      {
        path: "reimbursement-form-category-modification",
        name: "ReimbursementFormCategoryModification",
        component: () => import("../views/finance/store/Reimbursement/Reimbursementformcategorymodification.vue"),
        meta: { group: "报销管理", icon: "Edit", title: "报销单修改" },
      },
      {
        path: "user-profile",
        name: "UserProfile",
        component: () => import("../views/finance/store/UserManagement/UserProfile.vue"),
        meta: { group: "员工管理", icon: "User", title: "个人中心" },
      },
      
      {
        path: "employee-management",
        name: "StoreEmployeeManagement",
        component: () => import("../views/finance/store/UserManagement/StoreEmployeeManagement.vue"),
        meta: { group: "员工管理", icon: "UserFilled", title: "员工管理" },
      },
      {
        path: "EmployeeSalaryDistribution",
        name: "EmployeeSalaryDistribution",
        component: () => import("../views/finance/store/UserManagement/EmployeeSalaryDistribution.vue"),
        meta: { group: "员工管理", icon: "UserFilled", title: "工资发放" },
      },
      {
        path: "role-management",
        name: "StoreRoleManagement",
        component: () => import("../views/finance/store/UserManagement/StoreRoleManagement.vue"),
        meta: { group: "员工管理", icon: "Key", title: "角色管理" },
      },
      {
        path: "EmployeePayrollManagement",
        name: "EmployeePayrollManagement",
        component: () => import("../views/finance/store/UserManagement/EmployeePayrollManagement.vue"),
        meta: { group: "员工管理", icon: "Wallet", title: "工资管理" },
      },
      {
        path: "SetEmployeePayroll",
        name: "SetEmployeePayroll",
        component: () => import("../views/finance/store/UserManagement/SetEmployeePayroll.vue"),
        meta: { group: "员工管理", icon: "SetUp", title: "薪资设置" },
      },
      {
        path: "employee-loan",
        name: "EmployeeLoan",
        component: () => import("../views/finance/store/UserManagement/employeeLoan.vue"),
        meta: { group: "员工管理", icon: "Loan", title: "个人借款" },
      },
      {
        path: "employee-loan-audit",
        name: "EmployeeLoanAudit",
        component: () => import("../views/finance/store/UserManagement/employeeLoanAudit.vue"),
        meta: { group: "员工管理", icon: "Checked", title: "借款审核" },
      },
      {
        path: "employee-loan-management",
        name: "EmployeeLoanManagement",
        component: () => import("../views/finance/store/UserManagement/employeeLoanManagement.vue"),
        meta: { group: "员工管理", icon: "List", title: "借款明细" },
      },
      {
        path: "reimbursement-audit",
        name: "ReimbursementAudit",
        component: () => import("../views/finance/store/Reimbursement/ReimbursementAudit.vue"),
        meta: { group: "报销管理", icon: "Checked", title: "报销审核" },
      },
      // {
      //   path: "expense-dashboard",
      //   name: "ExpenseDashboard",
      //   component: () => import("../views/finance/store/Reimbursement/ExpenseDashboard.vue"),
      //   meta: { group: "报销管理", icon: "DataBoard", title: "分类统计" },
      // },
      //资金往来页面
      {
        path: "ZJWL",
        name: "ZJWL",
        component: () => import("../views/finance/store/Financialmanagement/ZJWL.vue"),
        meta: { group: "资金往来", icon: "Money", title: "往来管理" },
      },
      // 拉卡拉交易中心
       
      {
        path: "transfer-application-list",
        name: "TransferApplicationList",
        component: () => import("../views/finance/store/LKL/TransferApplicationList.vue"),
        meta: { group: "交易中心", icon: "Tickets", title: "企业支付" },
      },
      {
        path: "bank-account-query",
        name: "BankAccountQueryStore",
        component: () => import("../views/finance/store/LKL/BankAccountQuery.vue"),
        meta: { group: "交易中心", icon: "Bankcard", title: "银行账户查询" },
      },
      {
        path: "lakala-personal-account",
        name: "LakalaPersonalAccountStore",
        component: () => import("../views/finance/store/LKL/PersonalAccountOpen.vue"),
        meta: { group: "交易中心", icon: "Exchange", title: "个人开户" },
      },
      {
        path: "ZJWLCompany",
        name: "ZJWLCompany",
        component: () => import("../views/finance/store/Financialmanagement/ZJWLCompany.vue"),
        meta: { group: "资金往来", icon: "OfficeBuilding", title: "往来单位" },
      },
      //股东部分
      {
        path: "ShareholderPage",
        name: "ShareholderPage",
        component: () => import("../views/finance/store/Shareholermanagement/ShareholderInvestmentStats.vue"),
        meta: { group: "股东管理", icon: "User", title: "股东信息" },
      },
      {
        path: "ShareholderPageZ",
        name: "ShareholderPageZ",
        component: () => import("../views/finance/store/Shareholermanagement/ShareholderInvestmentTZ.vue"),
        meta: { group: "股东管理", icon: "Coin", title: "投资明细" },
      },
      {
        path: "ShareholderPageF",
        name: "ShareholderPageF",
        component: () => import("../views/finance/store/Shareholermanagement/ShareholderInvestmentFH.vue"),
        meta: { group: "股东管理", icon: "Money", title: "分红记录" },
      },
      {
        path: "ShareholderPageJ",
        name: "ShareholderPageJ",
        component: () => import("../views/finance/store/Shareholermanagement/ShareholderInvestmentTJ.vue"),
        meta: { group: "股东管理", icon: "TrendCharts", title: "报表分析" },
      },
      {
        path: "MyShareholder",
        name: "MyShareholder",
        component: () => import("../views/finance/store/Shareholermanagement/MyShareholder.vue"),
        meta: { group: "股东管理", icon: "UserFilled", title: "我的股权" },
      },
      {
        path: "zcmaterials-management",
        name: "ZCMaterialsManagement",
        component: () => import("../views/finance/store/Materialsmanagement/ZCMaterialsManagement.vue"),
        meta: { group: "资产管理", icon: "Box", title: "资产库存" },
      },
      {
        path: "zcmaterials-category",
        name: "ZCMaterialsCategory",
        component: () => import("../views/finance/store/Materialsmanagement/ZCMaterialsCategory.vue"),
        meta: { group: "资产管理", icon: "Grid", title: "资产分类" },
      },
      {
        path: "InvestmentProjects",
        name: "InvestmentProjects",
        component: () => import("../views/finance/store/Investmentmanagerment/InvestmentProjectManagement.vue"),
        meta: { group: "投资管理", icon: "OfficeBuilding", title: "项目单位" },
      },
      {
        path: "InvestmentRecords",
        name: "InvestmentRecords",
        component: () => import("../views/finance/store/Investmentmanagerment/InvestmentRecordManagement.vue"),
        meta: { group: "投资管理", icon: "Document", title: "投资记录" },
      },
      {
        path: "InvestmentAnalytics",
        name: "InvestmentAnalytics",
        component: () => import("../views/finance/store/Investmentmanagerment/InvestmentAnalytics.vue"),
        meta: { group: "投资管理", icon: "DataAnalysis", title: "投资分析" },
      },
      {
        path: "category-management",
        name: "CategoryManagement",
        component: () => import("../views/finance/store/Reimbursement/CategoryManagement.vue"),
        meta: { group: "财务设置", icon: "Operation", title: "报销分类" },
      },
      {
        path: "income-category",
        name: "IncomeCategoryManagement",
        component: () => import("../views/finance/store/Incomemanagement/IncomeCategoryManagement.vue"),
        meta: { group: "财务设置", icon: "Folder", title: "收入分类" },
      },
      {
        path: "ClassRelevance",
        name: "ClassRelevance",
        component: () => import("../views/finance/store/Homepage/ClassRelevance.vue"),
        meta: { group: "财务设置", icon: "Connection", title: "分类关联" },
      },
      {
        path: "audit-settings",
        name: "StoreAuditSettings",
        component: () => import("../views/finance/store/Reimbursement/StoreAuditSettings.vue"),
        meta: { group: "财务设置", icon: "SetUp", title: "审核设置" },
      },
      {
        path: "cashbalance-page",
        name: "Cashbalance",
        component: () => import("../views/finance/store/Homepage/CashBalance.vue"),
        meta: { group: "财务设置", icon: "SetUp", title: "资金设置" },
      },
      {
        path: "StoreSetup",
        name: "StoreSetup",
        component: () => import("../views/finance/store/Others/StoreSetup.vue"),
        meta: { group: "财务设置", icon: "SetUp", title: "基础设置" },
      },
      {
        path: "GPReporting",
        name: "GPReporting",
        component: () => import("../views/finance/store/Others/GPReporting.vue"),
        meta: { group: "收入管理", icon: "TrendingUp", title: "毛利报表" },
      },
      
      // {
      //   path: "lakala-personal-account-query",
      //   name: "LakalaPersonalAccountQueryStore",
      //   component: () => import("../views/finance/store/LKL/PersonalAccountQuery.vue"),
      //   meta: { group: "交易中心", icon: "Document", title: "开户结果查询" },
      // },
      // {
      //   path: "lakala-account-query",
      //   name: "LakalaAccountQueryStore",
      //   component: () => import("../views/finance/store/LKL/LakalaAccountQuery.vue"),
      //   meta: { group: "交易中心", icon: "List", title: "账户查询" },
      // },
      {
        path: "personal-account-info-query",
        name: "PersonalAccountInfoQueryStore",
        component: () => import("../views/finance/store/LKL/PersonalAccountInfoQuery.vue"),
        meta: { group: "交易中心", icon: "User", title: "个人钱包" },
      },
       {
        path: "personal-transaction-query",
        name: "PersonalTransactionQueryStore",
        component: () => import("../views/finance/store/LKL/PersonalTransactionQuery.vue"),
        meta: { group: "交易中心", icon: "Document", title: "钱包查询" },
      },
      {
        path: "transaction-apply",
        name: "TransactionApplyStore",
        component: () => import("../views/finance/store/LKL/TransactionApply.vue"),
        meta: { group: "交易中心", icon: "Edit", title: "退款申请" },
      },
      {
        path: "transaction-confirm",
        name: "TransactionConfirmStore",
        component: () => import("../views/finance/store/LKL/TransactionConfirm.vue"),
        meta: { group: "交易中心", icon: "Check", title: "交易确认" },
      },
     
      {
        path: "store-transaction-query",
        name: "StoreTransactionQueryStore",
        component: () => import("../views/finance/store/LKL/StoreTransactionQuery.vue"),
        meta: { group: "交易中心", icon: "Shop", title: "交易查询" },
      },
      {
        path: "lakala-account-list",
        name: "LakalaAccountListStore",
        component: () => import("../views/finance/store/LKL/LakalaAccountList.vue"),
        meta: { group: "交易中心", icon: "List", title: "账户列表查询" },
      },
     
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 路由守卫保持不变
router.beforeEach((to, from, next) => {
  const suserinfo = localdata();
  const userinfo = suserinfo.userinfo;
  console.log("用户信息:", userinfo);
  if (to.path === "/login") {
    document.title = "智店掌财管家企业数字化人.财管理系统-登录";
  } else if (to.path.startsWith("/finance/admin") || to.path.startsWith("/finance/store")) {
    document.title = "智店掌财管家企业数字化人.财管理系统";
  } else {
    document.title = "智店掌财管家企业数字化人.财管理系统";
  }

  // 检查要访问的路由是否需要登录
  // const requiresAuth =
  //   !to.path.startsWith("/user") &&
  //   to.path !== "/login" &&
  //   to.path !== "/finance/login";

  if (to.path.startsWith("/index")) {
    // 如果不是财务系统，则直接访问

    next()
    return;



  } else if ((to.path.startsWith("/finance/admin") || to.path.startsWith("/finance/store")) && to.path !== "/login") {
    // 检查财务报销系统登录状态
    let reimbursementUser = null;
    try {
      reimbursementUser = suserinfo.userinfo;
    } catch (error) {
      console.error("解析出错1");
    }
    console.log(
      "用户信息:",
      suserinfo.userinfo,
      "localStorage中的信息:",
      localStorage.getItem("userinfo")
    );

    console.log("路由信息:", router);
    console.log("报销用户信息:", reimbursementUser);
    // 检查用户是否已登录（检查是否有用户信息对象以及必要的字段）
    if (
      !reimbursementUser ||
      !reimbursementUser.姓名 ||
      reimbursementUser.姓名 === ""
    ) {
      // 未登录，重定向到财务系统登录页面
      console.log("需要进入登录界面");
      next("/login");
      //检查用户权限
    } else {
      // 只有当访问的是 /finance/store 或 /finance/admin 根路径时才进行重定向
      console.log("用户类型" + reimbursementUser.用户类型);
      if (
        to.path === "/finance/store" &&
        (reimbursementUser.用户类型 === 1 || reimbursementUser.用户类型 === 3)
      ) {
        // 门店管理员访问门店端首页，重定向到报销填写页面
        console.log("到这里了1");
        next("/finance/store/dashboard");
        return;
      } else if (
        to.path === "/finance/admin" &&
        (reimbursementUser.用户类型 === 0 || reimbursementUser.用户类型 === 2)
      ) {
        // 管理员访问管理端首页，重定向到报销管理页面
        console.log("到这里了2");
        next("/finance/admin/dashboard");
        return;
      } else if (
        (reimbursementUser.用户类型 === 0 ||
          reimbursementUser.用户类型 === 2) &&
        to.path.startsWith("/finance/store")
      ) {
        // 管理员试图访问门店端页面，重定向到管理端
        console.log("到这里了3");
        next("/finance/admin/dashboard");
        return;
      } else if (
        reimbursementUser.用户类型 === 1 &&
        to.path.startsWith("/finance/admin")
      ) {
        // 门店管理员试图访问管理端页面，重定向到门店端
        console.log("到这里了4");
        next("/finance/store/dashboard");
        return;
      }

      // 其他情况允许访问
      console.log("允许访问路由:", to.path);
      
      // 添加权限检查：如果访问的是dashboard且用户没有首页权限，则重定向到个人中心
      if (to.path === "/finance/store/dashboard" || to.path === "/finance/admin/dashboard") {
        try {
          const userPermissions = JSON.parse(reimbursementUser.角色权限);
          const hasHomepagePermission = Object.keys(userPermissions).includes("首页");
          
          if (!hasHomepagePermission) {
            console.log("用户没有首页权限，重定向到个人中心");
            // 根据用户类型重定向到对应的个人中心
            if (reimbursementUser.用户类型 === 1 || reimbursementUser.用户类型 === 3) {
              next("/finance/store/user-profile");
            } else {
              next("/finance/admin/AdminUserProfile");
            }
            return;
          }
        } catch (e) {
          console.error("解析权限失败:", e);
        }
      }
      
      next();
    }
  } else {
    // 不需要登录的页面或财务系统登录页面，直接访问
    next();
  }
});

export default router;